import { Box, styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const RadioQuestion = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #5b5675;
  line-height: 20px;
`;

export const RadioSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DividerContainer = styled.div`
  border: 1px dashed #e7e7f0;
`;

export const InputContainer = styled(Box)`
  position: relative;
  margin: 24px 0 1rem;
`;

export const BorderBox = styled(Box)`
  border: 1px solid #d6d9e0;
  border-radius: 8px;
  padding: 12px 16px 16px;
  position: relative;
  margin-bottom: ${props => props.isCommercialVehicle && "10px"};
`;

export const InputBox = styled.input`
  outline: none;
  height: 48px;
  margin: 0 0 1.5rem;
  padding: 16px 1rem;
  width: 100%;
  border: 1px solid #e4eaf1;
  border-radius: 8px;
  text-align: left;
  width: 100%;
  color: #5c5d66;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid #dcdce0;
  ::placeholder {
    color: #dcdce0;
    font-size: 0.875rem;
  }
`;

export const Note = styled(Text)`
  font-size: 0.625rem;
  line-height: 17px;
  color: #8a99a9;
  position: absolute;
  top: ${props => (props.showError ? "64px" : "54px")};
  text-align: left;
  width: 90%;
  left: 5px;
`;

export const ErrorText = styled(Text)`
  font-weight: 500;
  color: #151619;
  margin: 0;
  font-size: 0.625rem;
  width: 90%;
  color: #fd4b44;
  text-align: left;
  line-height: 0;
  padding-top: 0.5em;
  margin: 8px auto 0;
  position: absolute;
  top: 45px;
  left: 18px;
`;

export const ItemContainer = styled(Flex)`
  padding: 10px 14px;
  background: #fff7e5;
  border-radius: 8px;
`;

export const TextContainer = styled(Flex)`
  margin-left: 10px;
  font-weight: normal;
  margin-top: 0.25rem;
  font-weight: 400;
  font-size: ${props => (props.isDesktop ? "12px" : "14px")};
  line-height: 20px;
  color: #040222;
  order: 1;
  flex-grow: 0;
`;

export const Error = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #fd4b44;
  position: absolute;
  bottom: -25px;
  left: 0px;
`;
